import { useFormMutation } from "@/hooks/useFormMutation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { APIError, ApiResponse, DataObject, DataPaginate } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { AudiencePayload } from "./validation";

const fetchIncomingLetterAudience = async (
  params?: string
): Promise<ApiResponse<DataPaginate<IncomingMailAudienceResponse>>> => {
  return await fetcher(`incoming-letters/audience?${params}`);
};

export const useGetIncomingLetterAudience = (params?: string) => {
  return useQuery<
    ApiResponse<DataPaginate<IncomingMailAudienceResponse>>,
    APIError
  >({
    queryKey: ["useGetIncomingLetterAudience", params],
    queryFn: async () => {
      const response = await fetchIncomingLetterAudience(params);
      return response;
    },
  });
};

export const useGetIncomingLetterAudienceDetail = (id: number) => {
  return useQuery<
    ApiResponse<DataObject<IncomingMailAudienceDetailResponse>>,
    APIError
  >({
    queryKey: ["useGetIncomingLetterVisitDetail", id],
    queryFn: async () => {
      const response = await fetcher(`incoming-letters/audience/${id}`);
      return response;
    },
    enabled: !!id,
  });
};

export const useIncomingLetterAudienceMutation = () => {
  return useFormMutation<
    ApiResponse<DataObject<AudiencePayload>>,
    APIError,
    AudiencePayload
  >({
    mutationFn: async (payload) => {
      return await sendData(`landing-forms/audience`, payload, "POST", true);
    },
    successMessage: `Berhasil Membuat Surat Permohonan Audiensi`,
  });
};
